import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';

import AboutPopup from './AboutPopup';

import plus from '../assets/img/plus.png';
import minus from '../assets/img/minus.png';

import RightPopup from './RightPopup';

class RightSide extends Component {
    constructor(props) {
        super(props)

        this.state = {
            closePopup: false,
            displayAbout: false
        }
    }

    displayAboutPopup = () => {
        this.setState({ displayAbout: !this.state.displayAbout, closePopup: !this.state.closePopup });
    }

    render() {
        const { t } = this.props;

        return (
            this.state.displayAbout
                ?
                <div>
                    <div className="more">
                        <span className="grey_pill" onClick={e => this.displayAboutPopup()}>{this.state.displayAbout ? <span className="aboutBtn"> {t("general.hideAbout")} <img src={minus} alt="" /> </span> : <span className="aboutBtn"> {t("general.about")} <img src={plus} alt="" /> </span>}</span>
                    </div>
                    <AboutPopup selectedQuestion="noToken" displayAbout={this.state.displayAbout} />
                </div>
                :
                <div>
                    <div className="more">
                        <span className="grey_pill" onClick={e => this.displayAboutPopup()}>{this.state.displayAbout ? <span className="aboutBtn"> {t("general.hideAbout")} <img src={minus} alt="" /> </span> : <span className="aboutBtn"> {t("general.about")} <img src={plus} alt="" /> </span>}</span>
                    </div>
                    {this.props.transferIsAvailable
                        ?
                        <RightPopup closePopup={this.state.closePopup} />
                        :
                        null
                    }
                </div>
        )
    }
}

export default withTranslation()(RightSide);